import { ProductInfoTypes } from './Product'

export const EanLabelTypes = ['sticker-standard', 'sticker-compressed'] as const
export type EanLabelType = (typeof EanLabelTypes)[number]

export const BarcodeTypes = ProductInfoTypes.filter((type) => type !== 'consumerItem')
export type BarcodeType = (typeof BarcodeTypes)[number]

export interface BarcodeOption {
  id: string
  title: string
  disabled?: boolean
  description?: string
}

export const EanOrientation = ['vertical', 'horizontal'] as const
export type EanOrientation = (typeof EanOrientation)[number]

export const RenderFormats = ['pdf', 'svg'] as const
export type RenderFormat = (typeof RenderFormats)[number]
